<script lang="ts">
    import Input from "../../../leafElement/Input.svelte";
    import QrScanner from "../../../leafElement/QrScanner.svelte";

    import { pushNewGroup } from "../../../script/din/dataBroker";

    import { getGroupNamePrewiew } from "../../../script/probeStore";

    import type { MesurmentFull } from "../../../script/types";

    export let allMesurment: MesurmentFull[];
    export let usedMesurment: MesurmentFull[];
    export let selectedMesurment: MesurmentFull[];
    export let resetChecks: () => void;
    let scannedMesList: MesurmentFull[] = [];

    $: usedMesurment =
        scannedMesList.length === 0 ? allMesurment : scannedMesList;
    $: selectedCount = selectedMesurment.length;

    let sugestedGroupName = getGroupNamePrewiew();
    let realGroupName = "";
    function newGroup() {
        if (selectedCount === 0) return;
        pushNewGroup(selectedMesurment, realGroupName ? realGroupName : null);
        resetChecks();
        sugestedGroupName = getGroupNamePrewiew();
        realGroupName = "";
    }

    let activeZoneWarn;
    function activeZoneAdd(param) {
        const dVal = param.detail;
        const probeToUpdate = allMesurment.filter(
            (mes) => mes.static.id === dVal
        );
        probeToUpdate
            .filter((probe) => !scannedMesList.includes(probe))
            .forEach((probe) => {
                scannedMesList.push(probe);
            });
        scannedMesList = [...scannedMesList];
        if (probeToUpdate.length === 0 && activeZoneWarn) {
            activeZoneWarn();
        }
    }
</script>

<div class="root">
    <div class="standartButton_SMargin borderBox simpleBox">
        <span class="simpleTitle simpleTitleShifted">Vybráno do skupiny:</span
        >
        <div class="simpleBoxInter">
            <span class="simpleText" style="margin-bottom: 2px;"
                >{selectedCount}</span
            >
            <div class="input">
                <Input
                    name={"Název skupiny"}
                    placeholder={sugestedGroupName}
                    bind:val={realGroupName}
                    on:enter={newGroup}
                />
            </div>
            <button
                disabled={selectedCount === 0}
                class="standartButton standartButton_SMargin"
                on:click={newGroup}>Přidat skupinu</button
            >
        </div>
    </div>
    <div class="standartButton_SMargin borderBox simpleBox">
        <span class="simpleTitle simpleTitleShifted">Zúžené zobrazení:</span>
        <div class="simpleBoxInter">
            <QrScanner
                bind:showError={activeZoneWarn}
                on:code={activeZoneAdd}
            />
            {#if scannedMesList.length !== 0}
                <div class="borderBox simpleBox">
                    <span class="simpleTitle">Zobrazeno:</span>
                    <div class="simpleBoxInter">
                        <span class="simpleText">{scannedMesList.length}</span>
                        <div
                            class="activeIcon inactiveIcon customIcon"
                            on:click={() => {
                                scannedMesList = [];
                            }}
                        >
                            <span class="material-icons"> clear </span>
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .root {
        display: flex;
    }
    .root > div {
        margin-right: 1.5rem;
    }
    .simpleTitle {
        font-size: 0.9rem;
        color: var(--back_D2);
        font-weight: 300;
        margin-bottom: 8px;
    }
    .simpleTitleShifted {
        align-self: flex-start;
        margin-left: 1.2rem;
    }
    .simpleBox {
        width: fit-content;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 8px 1rem 0.5rem 1rem;
        margin: 0.5rem;
    }
    .simpleBox .input {
        width: 8rem;
    }
    .simpleBoxInter {
        display: flex;
        align-items: center;
    }
    .simpleText {
        font-size: 1.9rem;
        margin-right: 0.5em;
        font-weight: 700;
        color: var(--back_D2);
    }
    .customIcon {
        margin: 0;
    }
</style>
